import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import {
  isTest,
} from '../../../redux/challengeSlice';

import '../../css/jb-styles.css';

export default function SelectorButtons() {
  const theme = useTheme();
  const [selectorIndex, setSelectorIndex] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const savePattern = () => {
    alert('Pattern stored');
  };

  const testPattern = () => {
    dispatch(isTest(true));
    navigate("/challenge");
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          // justifyContent: 'center',
          justifyContent: 'space-around',
          paddingLeft: '20px',
          paddingRight: '20px',
        }}
      >
        <Box
          sx={{
            width: '45%',
          }}
        >

          <Button
            variant="outlined"
            sx={{
              width: '100%',
              color: '#3B4E68',
              border: '1px solid #3B4E68',
              backgroundColor: '#FFFFFF',
              '&:hover': {
                color: '#FFFFFF',
                backgroundColor: '#3B4E68',
              }
            }}
            onClick={testPattern}
          >
            Test pattern
          </Button>
        </Box>

        <Box
          sx={{
            width: '45%',
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: '100%',
              backgroundColor: '#3B4E68',
              color: '#FFFFFF',
              '&:hover': {
                color: '#3B4E68',
                border: '1px solid #3B4E68',
                // backgroundColor: '#FFFFFF',
                backgroundColor: '#60A5FA',
              }
            }}
            onClick={savePattern}
          >
            Save pattern
          </Button>

        </Box>

      </Box>
    </React.Fragment>
  );
}